import styled from 'styled-components';
import { MiniMap } from 'reactflow';
import { Box, Button as MUIButton } from '@mui/material';

export const Container = styled(Box)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ButtonsWrapper = styled(Box)`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing(0, 0, 1, 3)};
`;

export const Button = styled(MUIButton)`
  &:not(:disabled) {
    color: ${({ theme }) => theme.palette.primary.main} !important;
    border-color: ${({ theme }) => theme.palette.primary.main} !important;
  }
`;

Button.defaultProps = {
  variant: 'outlined',
};

export const StyledMiniMap = styled(MiniMap)`
  &.react-flow__minimap {
    opacity: 0.8;
  }
`;
